import type { PagedEnqueueFailure } from "./types"

export interface EnqueueErrorView {
  text: string
  /** Живая enqueuing-рассылка: показывать отмену и блокировать повторный сабмит. */
  mailingLive: boolean
}

export const mapEnqueueError = (
  failure: PagedEnqueueFailure,
): EnqueueErrorView => {
  switch (failure.kind) {
    case "invalid-recipient-count":
      return {
        text: `Получателей должно быть от 1 до 200 000 (сейчас: ${failure.count}).`,
        mailingLive: false,
      }
    case "bad-request":
      return {
        text: "Некорректный запрос (ошибка формы). Обратитесь к разработке.",
        mailingLive: true,
      }
    case "page-too-large":
      return {
        text: "Слишком большой объём данных страницы.",
        mailingLive: true,
      }
    case "not-found":
      return {
        text: "Рассылка не найдена или уже удалена.",
        mailingLive: false,
      }
    case "hash-mismatch":
      return {
        text: "Внутренняя ошибка (изменились данные страницы). Отмените рассылку и создайте заново.",
        mailingLive: true,
      }
    case "closed":
      return {
        text: "Рассылка закрывается: зафиксирован досрочный финиш.",
        mailingLive: false,
      }
    case "aborted":
      return { text: "Рассылка была отменена.", mailingLive: false }
    case "limit":
      return {
        text: "Достигнут потолок 200 000 получателей. Досылка невозможна — отмените рассылку.",
        mailingLive: true,
      }
    case "http":
      return {
        text: failure.message ?? `Ошибка запроса (HTTP ${failure.status}).`,
        mailingLive: true,
      }
    case "commit-stuck":
      return {
        text: "Не удалось зафиксировать рассылку (рассинхрон счётчиков). Отмените рассылку или обратитесь к администратору.",
        mailingLive: true,
      }
    case "finalized-or-purged":
      return {
        text: "Рассылка уже завершена или удалена — проверьте завершённые рассылки.",
        mailingLive: false,
      }
    case "retry-exhausted":
      return {
        text: "Сервер не отвечает. Можно повторить — рассылка продолжится с той же страницы.",
        mailingLive: true,
      }
    case "cancelled-by-user":
    case "aborted-local":
      return { text: "", mailingLive: failure.kind === "aborted-local" }
  }
}
